import { render, staticRenderFns } from "./mainManage.vue?vue&type=template&id=8c7d2962&scoped=true&"
import script from "./mainManage.vue?vue&type=script&lang=js&"
export * from "./mainManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d2962",
  null
  
)

export default component.exports